import { ArticuloUnidadMedidaProp } from '../../unidadMedida/interfaces'

/**
 * @description Definición de unidades de medida por cantidad
 * Las operaciones se basan segun la unidad de medida minima cuya cantidad base = 1
 */
export interface GrupoUnidadMedidaDefinicionProp {
  unidadMedida: ArticuloUnidadMedidaProp // Código que identifica a la unidad de medida, se replica con sin unidad medida
  cantidadBase: number
}

/**
 * @description Propiedades que debe tener un grupo de unidad de medida
 * Si realiza una operación de articulo, ya no podrá modificar su grupo de UM.
 */
export interface GrupoUnidadMedidaProp {
  _id: string
  codigoGrupo: string // Código que identifica al grupo de unidad de medida
  nombreGrupo: string // descripcion del grupo de unidad de medida
  unidadMedidaBase?: ArticuloUnidadMedidaProp // unidad de medida base del grupo
  codigoUnidadMedidaBase: ArticuloUnidadMedidaProp // unidad de medida base del grupo
  definicion: GrupoUnidadMedidaDefinicionProp[]
  state?: string // estado del registro
  usucre?: string
  usumod?: string
}

export interface GrupoUnidadMedidaDefinicionProp2 {
  cantidadBase: number // cantidad base de la unidad de medida
  unidadMedida?: ArticuloUnidadMedidaProp // unidad de medida base del grupo
}

export interface GrupoUnidadMedidaProp2 {
  //codigoGrupo: string // Código que identifica al grupo de unidad de medida
  nombreGrupo: string // descripcion del grupo de unidad de medida
  unidadMedidaBase?: ArticuloUnidadMedidaProp // unidad de medida base del grupo
  codigoUnidadMedidaBase: ArticuloUnidadMedidaProp // unidad de medida base del grupo
  definicion: GrupoUnidadMedidaDefinicionProp2[]
}

export interface GrupoUnidadMedidaInputProps {
  //codigoGrupo: number | null
  nombreGrupo: string
  codigoUnidadMedidaBase: string
  definicion: GrupoUnidadMedidaDefinicionInputProp[]
}
export interface GrupoUnidadMedidaDefinicionInputProp {
  codigoUnidadMedida: string // Código que identifica a la unidad de medida, se replica con sin unidad medida
  cantidadBase: number
}

export interface GrupoUnidadMedidaInputProps2 {
  //codigoGrupo: number | null
  nombreGrupo: string
  codigoUnidadMedidaBase: string
  definicion: GrupoUnidadMedidaDefinicionProp[]
}

export interface GrupoUnidadMedidaListadoProps {
  _id: string
  // descripcion del grupo de unidad de medida
  unidadMedidaBase?: ArticuloUnidadMedidaProp // unidad de medida base del grupo
  nombreGrupo: string
  codigoUnidadMedidaBase: ArticuloUnidadMedidaProp
  definicion: {
    unidadMedida: ArticuloUnidadMedidaProp
    cantidadBase: number
  }[] // definicion de unidades de medida por cantidad
}

export const GRUPO_UNIDAD_MEDIDA_INITIAL_VALUES: GrupoUnidadMedidaInputProps = {
  //codigoGrupo: null,
  nombreGrupo: '',
  codigoUnidadMedidaBase: '',
  definicion: [],
}
